import React from 'react';
import { useParams } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import DetalleBaja from './DetalleBaja';
import PantallaProceso from './PantallaProceso';
import { RUTA_BAJAS } from './rutasProceso';

/**
 * BajaPage — la baja con su propia ruta (FASE_PANTALLA_DE_ALTA_Y_BAJA.md, §6, pieza 1).
 *
 * El `:id` se valida AQUÍ, antes de pedir nada: `/…/bajas/abc` no es «no existe», es una URL que
 * no es de una baja, y mandarla al servidor sólo la convertiría en un error menos claro.
 *
 * `key` fuerza a montar de nuevo al pasar de una baja a otra: el componente guarda en su estado el
 * detalle y lo que se está editando, y nada de eso debe sobrevivir al cambio de id.
 */
export default function BajaPage() {
  const { id } = useParams();
  if (!/^[1-9][0-9]*$/.test(String(id || ''))) {
    return (
      <PantallaProceso rutaListado={RUTA_BAJAS}>
        <div className="px-5 py-12 text-center text-sm text-v25-ink-700">
          <AlertCircle className="mx-auto mb-2 h-6 w-6 text-v25-ink-400" />
          «{id}» no es el número de una baja.
        </div>
      </PantallaProceso>
    );
  }
  return <DetalleBaja key={id} bajaId={Number(id)} />;
}
